import React, { useState, useEffect, useRef } from 'react'
import { Form, Button, notification, Row, Col, Input, Card, DatePicker, Tooltip, Tag, Icon } from 'antd'
import { useDispatch } from 'react-redux'
import { countryIds, InputBox } from '../../../components/_utils/appUtils'
import { listAllCountries } from '../../countries/actions/countries'
import { getAllWithdrawalLimitFxn, updateWithdrawalLimitFxn } from '../actions/user'
import { TableComp } from 'sz-react-utils-lite'
import moment from 'moment'
import FutureDateWithdrawalList from './futureDateWithdrawalList'
import UsedLimitWithdrawalList from './usedLimitWithdrawals'
// import EditLimitWithdrawalList from '../withdrawalLimit/editWithdrawalLimit'

// let { DatePicker } = Date

const UpdateWithdrawalLimit = (props) => {
  let { user } = props
  const dispatch = useDispatch()
  const tableRef = useRef()
  const tableRef2 = useRef()
  let initialState = {
    withdrawalLimitDate: '',
    withdrawalLimit: '',
    countryId: ''
  }
  const [withdrawalLimitData, setWithdrawalLimitData] = useState(initialState)
  const [countryList, setCountryList] = useState([])
  const [canadaTotal, setCanadaTotal] = useState(0)
  const [ukTotal, setUkTotal] = useState(0)
  let [withdrawalDrawer, setWithdrawalDrawer] = useState({
    visible: false,
    countryId: '',
    name: ''
  })

  let [usedLimitWithdrawalDrawer, setUsedLimitWithdrawalDrawer] = useState({
    visible: false,
    countryId: '',
    withdrawalLimitId: ''
  })

  let [updateWithdrawalLimitDrawer, setUpdateWithdrawalLimitDrawer] = useState({
    visible: false,
    countryId: '',
    withdrawalLimitId: '',
    withdrawalLimit: ''
  })

  const events = {
    showWithdrawalListDrawer: (countryId, name) => {
      setWithdrawalDrawer({
        visible: true, countryId: countryId, name: name
      })
    },
    hideWithdrawalLisDrawer: () => {
      setWithdrawalDrawer({
        visible: false, countryId: '', name: ''
      })
    },
    showUsedLimitWithdrawalDrawer: (withdrawalLimitId, countryId) => {
      setUsedLimitWithdrawalDrawer({
        visible: true, countryId: countryId, withdrawalLimitId: withdrawalLimitId
      })
    },
    hideUserLimitWithdrawalDrawer: () => {
      setUsedLimitWithdrawalDrawer({
        visible: false, countryId: '', withdrawalLimitId: ''
      })
    },
    showUpdateWithdrawalLimit: (countryId, withdrawalLimitId, withdrawalLimit) => {
      setUpdateWithdrawalLimitDrawer({
        visible: true, countryId: countryId._id, withdrawalLimitId: withdrawalLimitId, withdrawalLimit: withdrawalLimit
      })
    },
    hideUpdateWithdrawalLimit: () => {
      setUpdateWithdrawalLimitDrawer({
        visible: false, countryId: '', withdrawalLimitId: '', withdrawalLimit: ''
      })
      tableRef.current.reload()
      tableRef2.current.reload()
    }
  }
  const _updateState = (data) => {
    setWithdrawalLimitData((prevState) => {
      return {
        ...prevState,
        ...data
      }
    })
  }

  const apiRequestUk = (params) => {
    return new Promise(async (resolve) => {
      params.countryId = countryIds.uk
      let { data } = await dispatch(getAllWithdrawalLimitFxn(params))
      setUkTotal(data.total)
      resolve(data)
    })
  }
  const apiRequestCanada = (params) => {
    return new Promise(async (resolve) => {
      params.countryId = countryIds.canada
      let { data } = await dispatch(getAllWithdrawalLimitFxn(params))
      setCanadaTotal(data.total)
      resolve(data)
    })
  }

  const handleSubmit = async () => {
    if (!withdrawalLimitData.withdrawalLimitDate) {
      return notification.warning({
        message: 'Please Choose Withdrawal Date'
      })
    }
    if (!withdrawalLimitData.withdrawalLimit) {
      return notification.warning({
        message: 'Please Enter Withdrawal Limit'
      })
    }
    if (!withdrawalLimitData.countryId) {
      return notification.warning({
        message: 'Please Choose Country'
      })
    }

    const resp = await dispatch(updateWithdrawalLimitFxn({ ...withdrawalLimitData }))
    if (resp.success) {
      setWithdrawalLimitData(initialState)
      tableRef.current.reload()
      tableRef2.current.reload()
    }
  }

  const loadCountryFxn = async () => {
    let params = {
      results: 100,
      count: 100,
      active: [true],
      _id: { $in: [countryIds.canada, countryIds.uk] }
    }
    let x = await dispatch(listAllCountries(params))
    setCountryList(x.data)
  }


  useEffect(() => {
    loadCountryFxn()
  }, [])


  const columns = [
    {
      title: <div className='WL-table-header'>Sr. No</div>,
      key: '_id',
      dataIndex: '_id',
      width: 80,
      render: (text, record, index) => (
        <div className='WL-cell-index'>{index + 1}</div>
      )
    },
    {
      title: <div className='WL-table-header'>Limit Date</div>,
      key: 'withdrawalLimitDate',
      dataIndex: 'withdrawalLimitDate',
      render: text => (
        <div className='WL-cell-date'>
          {text && moment(text).format('DD MMM YYYY') || '--'}
        </div>
      )
    },
    {
      title: <div className='WL-table-header'>Limit</div>,
      key: 'withdrawalLimit',
      dataIndex: 'withdrawalLimit',
      render: (text, record) => {
        const currency =
          record && record.countryId && record.countryId.currency &&
          record.countryId.currency || '--'
        return (
          <div className='WL-cell-limit-green'>
            {currency + ' ' + text}
          </div>
        )
      }
    },
    {
      title: <div className='WL-table-header'>Used Limit</div>,
      key: 'usedLimit',
      dataIndex: 'usedLimit',
      render: (text, record) => {
        const currency =
          record && record.countryId && record.countryId.currency &&
          record.countryId.currency || '--'
        return (
          <div className='WL-cell-limit-red btn btn-link hyperLinkUnderLine'
               onClick={() => {
                 events.showUsedLimitWithdrawalDrawer(record._id, record.countryId._id)
               }}
          >
            {currency + ' ' + (text || '0')}
          </div>
        )
      }
    },
    {
      title: <div className='WL-table-header'>Remaining</div>,
      key: 'remainingLimit',
      dataIndex: 'remainingLimit',
      render: (text, record) => {
        const currency =
          record && record.countryId && record.countryId.currency &&
          record.countryId.currency || '--'
        return (
          <div className='WL-cell-limit-yellow'>
            {currency + ' ' + (text || '0')}
          </div>
        )
      }
    },
    /*{
      title: <div className='WL-table-header'>Edit</div>,
      key: 'remainingLimit',
      dataIndex: 'remainingLimit',
      render: (text, record) => {
        return (
          <Icon
            className={'btn btn-default'}
            type={'edit'}
            onClick={() => {
              events.showUpdateWithdrawalLimit(record.countryId, record._id, record.withdrawalLimit)
            }}
          />
        )
      }
    }*/
  ]


  return (
    <div className='row'>
      <div className='col-lg-12'>
        <Form>
          <div className='form-box mt-4'>
            <div className='d-flex align-items-center mb-3 heading-form'>
              <h5>Add Withdrawal Limit</h5>
            </div>

            <div className='card unizportal'>
              <Row gutter={24}>
                <Col span={6}>
                  <InputBox title={'Country List'}>
                    <select
                      className={'form-control'}
                      value={withdrawalLimitData.countryId}
                      onChange={({ target }) => {
                        _updateState({
                          countryId: target.value
                        })
                      }}>
                      <option value={''}>Choose Country</option>
                      {countryList && countryList.length && countryList.map((item) => {
                        return (
                          <option key={item._id} value={item._id}>
                            {item.countryName}
                          </option>
                        )
                      })}
                    </select>
                  </InputBox>
                </Col>
                <Col span={6}>
                  <InputBox title={'Withdrawal Limit Date'}>
                    <DatePicker
                      value={withdrawalLimitData.withdrawalLimitDate}
                      className={'form-control'}
                      placeholder='Choose Withdrawal Limit Date'
                      onChange={(value) => _updateState({ withdrawalLimitDate: value })}
                    />
                  </InputBox>
                </Col>
                <Col span={6}>
                  <InputBox title={'Withdrawal Limit'}>
                    <Input
                      type={'number'}
                      value={withdrawalLimitData.withdrawalLimit}
                      className={'form-control'}
                      placeholder='Enter Withdrawal Limit'
                      onChange={(e) => _updateState({ withdrawalLimit: e.target.value })}
                    />
                  </InputBox>
                </Col>
              </Row>
              <Form.Item>
                <Button
                  type='primary'
                  htmlType='submit'
                  className='btn'
                  onClick={handleSubmit}
                >
                  Add
                </Button>
              </Form.Item>
            </div>
            <div className='withdrawal-limit'>
              <div className='card d-flex' style={{ flex: 1 }}>
                <div className='table-head d-flex align-items-center justify-content-between p0'>
                  <div className='d-flex align-items-center gap-3'>
                    <img className='countryFlagWl' src='/dist/img/canadaFlag.png' alt='' />
                    <h6 className='mb-0'>Canada Withdrawal Limits ({canadaTotal || 0})</h6>
                  </div>
                  <a className='btn btn-default roundNew2'
                     onClick={() => {
                       events.showWithdrawalListDrawer(countryIds.canada, 'Canada')
                     }}>
                    Future Withdrawals
                  </a>
                </div>


                <div className='card-body table-responsive'>
                  <TableComp
                    columns={columns}
                    ref={tableRef}
                    apiRequest={apiRequestCanada}
                  />
                </div>
              </div>

              <div className='card' style={{ flex: 1 }}>
                <div className='table-head d-flex align-items-center justify-content-between p0'>
                  <div className='d-flex align-items-center gap-3'>
                    <img className='countryFlagWl' src='/dist/img/united-kingdomFlag.png' alt='' />
                    <h6 className='mb-0'>UK Withdrawal Limits ({ukTotal || 0})</h6>
                  </div>
                  <a className='btn btn-default roundNew2'
                     onClick={() => {
                       events.showWithdrawalListDrawer(countryIds.canada, 'UK')
                     }}>
                    Future Withdrawals
                  </a>
                </div>

                <div className='card-body table-responsive'>
                  <TableComp
                    columns={columns}
                    ref={tableRef2}
                    apiRequest={apiRequestUk}
                  />
                </div>
              </div>
            </div>
            {withdrawalDrawer.visible ?
              <FutureDateWithdrawalList
                {...withdrawalDrawer}
                onClose={events.hideWithdrawalLisDrawer} /> : null}

            {usedLimitWithdrawalDrawer.visible ?
              <UsedLimitWithdrawalList
                {...usedLimitWithdrawalDrawer}
                onClose={events.hideUserLimitWithdrawalDrawer} /> : null}

            {/*{updateWithdrawalLimitDrawer.visible ?
              <EditLimitWithdrawalList
                {...updateWithdrawalLimitDrawer}
                onClose={events.hideUpdateWithdrawalLimit} /> : null}*/}
          </div>
        </Form>
      </div>
    </div>
  )
}

export default UpdateWithdrawalLimit
